<!-- 三方推流设置界面 -->
<template>
  <div class="vmp-third-stream" v-show="isShowThirdStream">
    <!-- 关闭按钮 -->
    <i
      v-if="isLeLeInteractMode || isLiveCommerceMode"
      class="vh-iconfont vh-line-close"
      @click="closeThirdStream"
    ></i>
    <!-- 第三方推流 -->
    <div class="vmp-third-stream-box">
      <div class="vmp-third-stream-title">
        {{ $t('host.k_543001') }}
        <span class="vmp-third-stream-subTitle">{{ $t('host.k_543002') }}</span>
      </div>
      <div class="vmp-third-stream-modal" :class="'streamModal' + streamModal">
        <div class="title">{{ $t('host.k_543003') }}</div>
        <vh-radio-group v-model="streamModal" :disabled="roomStatus == 1">
          <vh-radio :label="1">{{ $t('host.k_543004') }}</vh-radio>
          <vh-radio :label="2">{{ $t('host.k_543005') }}</vh-radio>
        </vh-radio-group>
        <div class="input-item" v-show="streamModal == 1">
          <label>RTMP/URL</label>
          <div class="vmp-third-stream-modal-input readOnly">
            <span class="input" :title="thirdWatchWebUrl">{{ thirdWatchWebUrl }}</span>
            <span class="tool">
              <span
                :title="$t('host.k_543006')"
                @click="doCopy(1)"
                class="vh-iconfont vh-line-copy"
              ></span>
            </span>
          </div>
        </div>
        <div class="input-item" v-show="streamModal == 1">
          <label>{{ $t('host.k_543007') }}</label>
          <div class="vmp-third-stream-modal-input readOnly">
            <span class="input" :title="thirdPlayUrl">{{ thirdPlayUrl }}</span>
            <span class="tool">
              <span
                :title="$t('host.k_543006')"
                @click="doCopy(2)"
                class="vh-iconfont vh-line-copy"
              ></span>
            </span>
          </div>
        </div>
        <div class="input-item" v-show="streamModal == 1">
          <label>{{ $t('host.k_543035') }}</label>
          <div class="vmp-third-stream-modal-input readOnly">
            <span class="input" :class="!!streamStatus ? 'success' : 'fail'">
              {{ !!streamStatus ? $t('host.k_543036') : $t('host.k_543037') }}
            </span>
            <span class="tool">
              <span
                :title="$t('host.k_543015')"
                @click="getThirdPushStreamStatus"
                class="vh-iconfont vh-line-refresh-right"
              ></span>
            </span>
          </div>
        </div>
        <div class="input-item" v-show="streamModal == 2">
          <label>
            <span class="required">*</span>
            {{ $t('host.k_543008') }}
          </label>
          <div
            class="vmp-third-stream-modal-input"
            :class="showRulePullUrl ? 'showRulePullUrl' : ''"
          >
            <vh-input
              v-model="pullUrl"
              :disabled="roomStatus == 1"
              @blur="validatePullUrl(true)"
              :placeholder="$t('host.k_543009')"
            ></vh-input>
            <span class="alert" v-show="showRulePullUrl">
              {{ pullUrl ? $t('host.k_543010') : $t('host.k_543011') }}
            </span>
          </div>
        </div>
        <div class="input-item" v-show="streamModal == 2">
          <label>{{ $t('host.k_543012') }}</label>
          <div class="vmp-third-stream-modal-input readOnly">
            <span class="input" v-if="pullStream.status == 2">
              {{ $t('host.k_543039') }}
            </span>
            <span class="input success" v-if="pullStream.status == -1">
              {{ $t('host.k_543038') }}
            </span>
            <span class="input fail" v-else-if="pullStream.status == 0">
              {{ $t('host.k_543014') }} （{{ $t('host.k_543042') }}{{ pullStream.validateTime }}）
            </span>
            <span class="input success" v-if="pullStream.status == 1">
              {{ $t('host.k_543013') }}（{{ $t('host.k_543042') }}{{ pullStream.validateTime }}）
            </span>
            <span class="tool">
              <vh-button type="text" @click="getThirdPullStreamStatus">
                {{ $t('host.k_543041') }}
              </vh-button>
            </span>
          </div>
        </div>
        <p v-show="streamModal == 2" class="tips">
          {{ $t('host.k_543040') }}
        </p>
        <div class="separator"></div>
        <template v-if="streamModal == 1">
          <div class="title">{{ $t('host.k_543016') }}</div>
          <div class="content">
            <p>{{ $t('host.k_543017') }}</p>
            <p>{{ $t('host.k_543018') }}</p>
            <p>{{ $t('host.k_543019') }}</p>
            <p>{{ $t('host.k_543020') }}</p>
            <p>{{ $t('host.k_543021') }}</p>
            <p style="color: #fb3a32">
              {{ $t('host.k_543022') }}
              <a
                style="color: #436dfa; margin-left: 10px"
                href="https://saas-doc.vhall.com/opendocs/show/1746"
                target="_blank"
              >
                {{ $t('host.k_543023') }}
              </a>
            </p>
          </div>
          <div class="title">
            {{ $t('host.k_543024') }}
            <a href="https://saas-doc.vhall.com/opendocs/show/1666" target="_blank">
              {{ $t('host.k_543023') }}
            </a>
          </div>
          <div class="content">
            <p>{{ $t('host.k_543025') }}</p>
            <p>{{ $t('host.k_543026') }}</p>
            <p>{{ $t('host.k_543027') }}</p>
            <p class="notice">{{ $t('host.k_543028') }}</p>
          </div>
        </template>
        <template v-else>
          <div class="title">{{ $t('host.k_543029') }}</div>
          <div class="content">
            <p>{{ $t('host.k_543030') }}</p>
            <p>{{ $t('host.k_543031') }}</p>
          </div>
          <div class="title">{{ $t('host.k_543032') }}</div>
          <div class="content">
            <p>{{ $t('host.k_543033') }}</p>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
  import { useRoomBaseServer, useInteractiveServer, useMsgServer } from 'middle-domain';
  import { boxEventOpitons, doCopy } from '@/app-shared/utils/tool';
  import regRule from '@/app-shared/utils/reg-rule.js';
  import { emitter, EMIT_DEFINE } from '@/app-shared/utils/emitter.js';
  import { throttle } from 'lodash';
  export default {
    name: 'VmpThirdStream',
    data() {
      return {
        thirdWatchWebUrl: '',
        thirdPlayUrl: '',
        isShowThirdStream: false,
        streamModal: 1,
        pullUrl: '',
        showRulePullUrl: false,
        pullStream: {
          status: 2, // 0-无，1-有，-1-检测中 2待检测
          validateTime: '' //检测时间点
        }
      };
    },
    beforeCreate() {
      this.roomBaseServer = useRoomBaseServer();
      this.msgServer = useMsgServer();
    },
    computed: {
      // 是否工具简单模式（乐乐专属）
      isLeLeInteractMode() {
        return this.$domainStore.state.roomBaseServer?.configList?.['lele_interact_model'];
      },
      // 是否直播带货模式
      isLiveCommerceMode() {
        return this.$domainStore.state.roomBaseServer?.configList?.['live_commerce_model'];
      },
      // 活动状态（2-预约 1-直播 3-结束 4-点播 5-回放）
      roomStatus() {
        return this.roomBaseServer.state.watchInitData.webinar.type;
      },
      isThirdStream() {
        return this.roomBaseServer.state.isThirdStream;
      },
      //是否有流：0-无，1-有
      streamStatus() {
        return this.roomBaseServer.state.streamStatus;
      },
      // 当前用户角色 1-主持人 2-观众(发起端没有观众) 3-助理；4-嘉宾（互动直播才有嘉宾）
      roleName() {
        return this.roomBaseServer.state.watchInitData.join_info.role_name;
      }
    },
    watch: {
      streamModal(val) {
        this.roomBaseServer.setThirdPullStreamMode(val);
      },
      pullUrl(val) {
        this.roomBaseServer.setThirdPullStreamUrl(val);
        if (val) {
          this.showRulePullUrl = false;
        }
      }
    },
    created() {
      if (this.roleName != 1) return;
      if (this.isThirdStream && this.roomStatus == 1) {
        this.isShowThirdStream = true;
        this.getThirdPushStream();
        this.getThirdPushStreamStatus();
        this.getDefaultStream();
      }
      this.getStreamPullAddress();
      emitter.on(EMIT_DEFINE.live_sidemenu_change, this.handleSidemenuChange);
      this.msgServer.$onMsg('ROOM_MSG', this.handleStreamValidation);
    },
    beforeDestroy() {
      emitter.off(EMIT_DEFINE.live_sidemenu_change, this.handleSidemenuChange);
      this.msgServer.$offMsg('ROOM_MSG', this.handleStreamValidation);
    },
    mounted() {
      useInteractiveServer().$on('live_over', _ => {
        if (this.roleName == 1) {
          this.isShowThirdStream = false;
          this.changePushImage(false);
          this.isShowThirdStream = false;
        }
      });
      if (this.isThirdStream && this.roomStatus == 1) {
        this.changePushImage(true);
      }
    },
    methods: {
      handleStreamValidation(msg) {
        if (msg.data.type == 'pull_stream_url_validation_status') {
          this.pullStream.status = Number(msg.data.status);
          this.pullStream.validateTime = msg.data.validate_time;
        }
      },
      getDefaultStream() {
        //开始类型：1-web（默认）， 2-app，3-sdk，4-推拉流，5-定时，6-admin后台， 7-第三方，8-windows客户端
        if (this.roomBaseServer.state.watchInitData.switch.start_type == 4) {
          //当switch.start_type=4时，pull.status 0-设置1,1-设置2
          this.streamModal = this.roomBaseServer.state.watchInitData.stream.pull.status ? 2 : 1;
          this.pullUrl = this.roomBaseServer.state.watchInitData.stream.pull.dest_url;
        }
      },
      async showThirdStream(info) {
        this.isShowThirdStream = info.status;
        this.roomBaseServer.setThirdPushStream(info.status);
        info.status && this.getThirdPushStream();
        await useInteractiveServer().switchBroadcast(Number(!info.status));
        info.status && this.getThirdPullStreamStatus();
        // trtc 需要开启三方发起的时候关闭旁路，但是关闭旁路有延迟，需要延迟五秒再检测拉流状态
        setTimeout(this.getThirdPushStreamStatus, 5000);
      },
      getThirdPushStream() {
        this.roomBaseServer.getThirdPushStreamAddress().then(res => {
          if (res.code == 200) {
            this.thirdPlayUrl = res.data.stream_code;
            this.thirdWatchWebUrl = res.data.stream_address;
          }
        });
      },
      //刷新房间内流状态
      getThirdPushStreamStatus() {
        this.roomBaseServer.getLiveStreamStatus({
          webinarId: this.$route.params.id
        });
      },
      getThirdPullStreamStatus: throttle(
        async function () {
          if (this.pullUrl) {
            const res = await this.roomBaseServer.getPullStreamStatus({
              webinar_id: this.$route.params.id,
              dest_url: this.pullUrl
            });
            if (res.code == 200) {
              this.pullStream.status = -1;
            } else {
              this.pullStream.status = 0;
            }
          }
        },
        2000,
        { trailing: false }
      ),
      getStreamPullAddress() {
        this.roomBaseServer.getStreamPullAddress().then(res => {
          if (res.code == 200) {
            this.pullUrl = res.data.dest_url;
          }
        });
      },
      changePushImage(flag) {
        const thirdBackground = document.querySelector('.vmp-basic-right__hd');
        if (thirdBackground) {
          if (flag) {
            thirdBackground.style.background = `url(${process.env.VUE_APP_STATIC_BASE}/common-static/images/thirdDefault.png) no-repeat`;
          } else {
            thirdBackground.style.background = `url(${process.env.VUE_APP_STATIC_BASE}/common-static/images/base-right.png) no-repeat`;
          }
          thirdBackground.style.backgroundSize = '100% 100%';
          thirdBackground.style.backgroundPosition = 'center';
        }
      },
      closeThirdStream() {
        this.isShowThirdStream = false;
      },
      doCopy(type) {
        doCopy(type == 1 ? this.thirdWatchWebUrl : this.thirdPlayUrl);
        this.$message({
          message: this.$t('host.k_543034'),
          showClose: true,
          type: 'success',
          customClass: 'zdy-info-box'
        });
      },
      //校验拉流地址非法性
      async validatePullUrl(cur = false) {
        if (!this.pullUrl) {
          this.showRulePullUrl = true;
        } else {
          const reg = regRule.pullUrl;
          if (reg.test(this.pullUrl)) {
            this.showRulePullUrl = false;
            if (!cur) {
              // 派发开始直播事件
              window.$middleEventSdk?.event?.send(
                boxEventOpitons(this.cuid, 'emitClickStartClick', [null, true])
              );
            } else {
              this.roomBaseServer.setStreamPullAddress({ dest_url: this.pullUrl });
            }
          } else {
            this.showRulePullUrl = true;
          }
        }
      },
      handleSidemenuChange({ kind }) {
        if (kind) {
          this.closeThirdStream();
        }
      }
    }
  };
</script>
<style lang="less">
  .vmp-third-stream {
    position: absolute;
    top: 0;
    left: 60px;
    width: calc(100% - 370px);
    height: 100%;
    background: #f1f1f1;
    z-index: 3;
    overflow-y: auto;

    .vh-line-close {
      position: absolute;
      top: 20px;
      right: 20px;
      &:hover {
        cursor: pointer;
      }
    }
    &-box {
      margin: 0 auto;
      width: 100%;
      height: 100%;
      .tips {
        margin-top: 5px;
        font-size: 14px;
        padding-left: 80px;
        line-height: 20px;
        width: 555px;
        color: #666;
      }
    }
    &-title {
      width: 720px;
      margin: 0 auto;
      padding-top: 32px;
      // height: 40px;
      padding-bottom: 10px;
      font-weight: 600;
      overflow: auto;
      font-size: 20px;
      line-height: 28px;
      color: #1a1a1a;
    }
    &-subTitle {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #999999;
      margin-left: 8px;
    }
    &-modal {
      width: 720px;
      margin: 0 auto;
      background: #ffffff;
      border-radius: 4px;
      padding: 24px;
      box-sizing: border-box;
      color: #1a1a1a;
      &.streamModal2 {
        .input-item label {
          min-width: 68px;
          width: 68px;
        }
        .required {
          color: #fb3a32;
        }
        input {
          border-color: #ccc;
        }
        .vh-input__inner:focus,
        .vh-textarea__inner:focus,
        .vh-input__inner:hover,
        .vh-textarea__inner:hover {
          border-color: #999;
        }
      }
      .title {
        font-weight: 600;
        font-size: 14px;
        line-height: 22px;
        color: #1a1a1a;
        position: relative;
        padding-left: 11px;
        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 4px;
          height: 14px;
          width: 3px;
          background-color: #fb3a32;
        }
        a {
          color: #436dfa;
          margin-left: 6px;
          font-weight: 400;
        }
      }
      .vh-radio-group {
        margin-top: 24px;
        .vh-radio {
          margin-right: 35px;
        }
        .vh-radio__label {
          color: #666;
        }
        .vh-radio__input.is-checked + .vh-radio__label {
          color: #1a1a1a;
        }
        .vh-radio__inner {
          width: 16px;
          height: 16px;
        }
        .vh-radio__inner::after {
          width: 8px;
          height: 8px;
        }
      }
      .input-item {
        margin-top: 24px;
        display: flex;
        align-items: center;
        color: #1a1a1a;
        label {
          min-width: 105px;
          width: 105px;
          text-align: right;
          font-size: 14px;
          line-height: 20px;
          margin-right: 12px;
        }
      }
      &-input {
        width: 555px;
        display: flex;
        align-items: center;
        height: 40px;
        box-sizing: border-box;
        position: relative;
        font-size: 14px;
        &.readOnly {
          border: 1px solid #cccccc;
          padding: 0 0 0 12px;
          background: #f7f7f7;
          border-radius: 4px;
        }
        &.showRulePullUrl {
          input {
            border: 1px solid #fb3a32;
          }
          .alert {
            color: #fb3a32;
            font-size: 12px;
            position: absolute;
            bottom: -17px;
          }
        }
        .input {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          width: 100%;
          &.success {
            color: #436dfa;
          }
          &.fail {
            color: #fb3a32;
          }
        }
        .tool {
          min-width: 29px;
          padding-right: 12px;
          text-align: right;
          .vh-iconfont {
            cursor: pointer;
            color: #666;
            &:hover {
              color: #1a1a1a;
            }
          }
        }
      }
      .separator {
        width: 100%;
        height: 40px;
      }
      .content {
        margin-top: 8px;
        margin-bottom: 24px;
        padding: 20px;
        background: #f7f7f7;
        border-radius: 4px;
        line-height: 22px;
        font-size: 14px;
        &:last-child {
          margin-bottom: 0;
        }
        .notice {
          margin-top: 5px;
          color: #666;
        }
      }
    }
  }
</style>
